import React from 'react'
import { Link, graphql } from 'gatsby'
import { Container } from '../components/container'
import { DndProvider } from 'react-dnd'
import { TouchBackend } from 'react-dnd-touch-backend'
import { HTML5Backend } from 'react-dnd-html5-backend'
import DefaultLayout from '../components/layout'
import SEO from '../components/seo'
import { BrowserView, MobileView } from 'react-device-detect'

const GamePage = ({ data }) => {
  const siteTitle = data.site.siteMetadata.title
  return (
    <DefaultLayout>
      <SEO
        title={siteTitle}
        keywords={[
          `chinese character learning`,
          `game`,
          `poem`,
          `children story`,
        ]}
      />
      <div className="content-box clearfix">
        <BrowserView>
          <DndProvider backend={HTML5Backend}>
            <Container />
          </DndProvider>
        </BrowserView>
        <MobileView>
          <DndProvider backend={TouchBackend}>
            <Container />
          </DndProvider>
        </MobileView>
      </div>
    </DefaultLayout>
  )
}

export default GamePage

export const pageQuery = graphql`
  query gamePageQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`
